import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ContentState } from './types';

export const initialState: ContentState = {
  trustItems: [],
};

export const { actions, reducer } = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setContent: (state, { payload }: PayloadAction<ContentState>) => {
      if (payload.offerLabel) {
        state.offerLabel = payload.offerLabel;
      }

      if (payload.membershipBanner) {
        state.membershipBanner = payload.membershipBanner;
      }

      state.trustItems = payload.trustItems;
    },
  },
});
